module.exports = __webpack_public_path__ + "media/images/v3/s_2-81d8f3bc6f00706c96fa99a1e05cfe9f.png";